import IndexRouteComponent from './index';
export default IndexRouteComponent;
